export default "__VITE_ASSET__CB8Yo$bD__"